import { hooksStore } from "../stores/hooks.store";
import { vygenerujIdZdroja } from "./map";

export function otvorPopup(gistyp, id, nazov, typ) {
  // vytvorim si ID pre zdroj mapboxu. Musi to byt jedinecne
  const source_id = vygenerujIdZdroja(gistyp, id);
  if (!source_id) {
    return false;
  }
  hooksStore.doAction("zobrazPopUpOknoPodlaSourceId", source_id, [
    gistyp,
    id,
    typ,
    nazov,
  ]);
}
